/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateIngressRequestBody,
  CreateIngressRequestBody$Outbound,
  CreateIngressRequestBody$outboundSchema,
} from "../components/createingressrequestbody.js";

export type CreateNetworkIngressSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateNetworkIngressRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createIngressRequestBody: CreateIngressRequestBody;
};

/** @internal */
export type CreateNetworkIngressSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateNetworkIngressSecurity$outboundSchema: z.ZodMiniType<
  CreateNetworkIngressSecurity$Outbound,
  CreateNetworkIngressSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createNetworkIngressSecurityToJSON(
  createNetworkIngressSecurity: CreateNetworkIngressSecurity,
): string {
  return JSON.stringify(
    CreateNetworkIngressSecurity$outboundSchema.parse(
      createNetworkIngressSecurity,
    ),
  );
}

/** @internal */
export type CreateNetworkIngressRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateIngressRequestBody: CreateIngressRequestBody$Outbound;
};

/** @internal */
export const CreateNetworkIngressRequest$outboundSchema: z.ZodMiniType<
  CreateNetworkIngressRequest$Outbound,
  CreateNetworkIngressRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createIngressRequestBody: CreateIngressRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createIngressRequestBody: "CreateIngressRequestBody",
    });
  }),
);

export function createNetworkIngressRequestToJSON(
  createNetworkIngressRequest: CreateNetworkIngressRequest,
): string {
  return JSON.stringify(
    CreateNetworkIngressRequest$outboundSchema.parse(
      createNetworkIngressRequest,
    ),
  );
}
